{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-tillägget är inte installerat.",
      "CTA": "Installera tillägg"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Historik"
    },
    "HISTORY": {
      "OPEN": "Öppna",
      "RECENT": "Senaste",
      "MISSED": "Missade",
      "LOADING": "Hämtar samtal...",
      "EMPTY": "Inga samtal här",
      "ERROR": "Det gick inte att läsa in samtalen",
      "CALL": "Ring tillbaka",
      "CALL_STATUS": {
        "BUTTON": "Ange samtalsstatus",
        "TITLE": "Samtalsstatus",
        "SEARCH_PLACEHOLDER": "Sök statusar...",
        "LOADING": "Hämtar statusar...",
        "NO_OPTIONS": "Inga samtalsstatusar har konfigurerats",
        "NO_MATCH": "Ingen status matchar",
        "OPTIONS_ERROR": "Det gick inte att läsa in statusarna",
        "RETRY": "Försök igen",
        "CONFIRM_QUESTION": "Ange ”{status}” och lös konversationen?",
        "CONFIRM": "Bekräfta",
        "BACK": "Tillbaka",
        "CANCEL": "Avbryt",
        "SAVING": "Sparar...",
        "SAVE_ERROR": "Det gick inte att spara statusen",
        "RESOLVE_ERROR": "Statusen sparades, men konversationen kunde inte lösas"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonnummer, t.ex. +421903000000",
      "BODY_PLACEHOLDER": "Skriv ditt meddelande ...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Skicka SMS",
      "SENDING": "Skickar ...",
      "SENT": "SMS skickat",
      "LOADING": "Läser in SMS-inkorgar ...",
      "NO_INBOX": "Det här kontot har ingen SMS-inkorg, så SMS kan inte skickas.",
      "INVALID_NUMBER": "Ange numret i internationellt format, inklusive det inledande +.",
      "ERROR": "SMS:et kunde inte skickas. Försök igen."
    },
    "ACTIONS": {
      "CONNECT": "Anslut",
      "GO_TO_TAB": "Gå till den fliken",
      "DISCONNECT": "Koppla från",
      "ANSWER": "Svara",
      "HANGUP": "Lägg på",
      "HOLD": "Parkera",
      "MUTE": "Stäng av mikrofon",
      "SILENCE": "Stäng av ljud",
      "TRANSFER": "Överför",
      "COMPLETE_TRANSFER": "Slutför överföring",
      "RETURN_TO_CALLER": "Återgå till uppringare",
      "CANCEL_TRANSFER": "Avbryt överföring",
      "DIALPAD": "Visa knappsats",
      "OPEN_CONVERSATION": "Öppna konversation"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Inkommande samtal",
      "INCOMING_CALL_FROM": "Inkommande samtal från {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Inkommande samtal från {number}",
      "ANSWER": "Svara",
      "DECLINE": "Avvisa"
    },
    "TRANSFER": {
      "TITLE": "Överför samtal",
      "PLACEHOLDER": "Ange mottagarens nummer...",
      "SEARCH_PLACEHOLDER": "Sök agenter...",
      "TARGET_PLACEHOLDER": "Vald mottagare",
      "CONFIRM": "Överför",
      "MODE_DIRECT": "Överför nu",
      "MODE_CONSULT": "Ring agent först",
      "CANCEL": "Avbryt"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Är du säker på att du vill gå på rast för alla köer?",
      "CONFIRM_READY": "Är du säker på att du vill återgå till redo-status för alla köer?",
      "CONFIRM_BREAK_QUEUE": "Är du säker på att du vill logga ut från kön {queue}?",
      "CONFIRM_READY_QUEUE": "Är du säker på att du vill logga in i kön {queue}?",
      "LOGIN_TO_QUEUE": "Logga in",
      "LOGOUT_FROM_QUEUE": "Logga ut",
      "LOGIN_TO_ALL_QUEUES": "Logga in i alla köer",
      "LOGOUT_FROM_ALL_QUEUES": "Logga ut från alla köer",
      "OPTION_LOGOUT": "Logga ut",
      "OPTION_BREAK": "Rast",
      "OPTION_LUNCH": "Lunch",
      "OPTION_AWAY": "Frånvarande",
      "OPTION_DO_NOT_DISTURB": "Stör ej",
      "OPTION_BUSINESS_TRIP": "Tjänsteresa",
      "CONFIRM": "Bekräfta",
      "CANCEL": "Avbryt"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Ingen anslutning till telefonsystemet",
      "MESSAGE": "Din internetanslutning verkar vara nere. Kontrollera den och försök igen.",
      "CREDENTIALS_TITLE": "Telefonsystemet avvisade dina inloggningsuppgifter",
      "CREDENTIALS_MESSAGE": "Telefonsystemet avvisade användarnamnet eller lösenordet som sparats i din profil. Kontrollera dem i Profilinställningar, eller kontakta din administratör.",
      "CONFIGURATION_TITLE": "Telefoninställningarna är inte giltiga",
      "CONFIGURATION_MESSAGE": "SIP-användarnamnet eller serveradressen har inte ett giltigt format, så telefonen kan inte ansluta. Åtgärda det i Profilinställningar.",
      "NETWORK_SHORT": "Anslutningen misslyckades",
      "CREDENTIALS_SHORT": "Inloggningsuppgifter avvisades",
      "CONFIGURATION_SHORT": "Ogiltiga telefoninställningar",
      "RETRY": "Försök igen",
      "DISMISS": "Avbryt"
    },
    "CONNECTION_QUALITY": "Anslutningskvalitet",
    "CONNECTION_QUALITY_EXCELLENT": "Utmärkt",
    "CONNECTION_QUALITY_GOOD": "Bra",
    "CONNECTION_QUALITY_FAIR": "Godtagbar",
    "CONNECTION_QUALITY_POOR": "Dålig",
    "CONNECTION_QUALITY_DISCONNECTED": "Frånkopplad",
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "Telefonen är ansluten i en annan flik",
      "CONNECTING": "Ansluter...",
      "DISCONNECTING": "Kopplar från...",
      "ONLINE": "Telefon online",
      "DIALING": "Ringer",
      "TRANSFERRING": "Överför...",
      "CONSULTING": "Pratar med agent",
      "CALLER_ON_HOLD": "Uppringaren är parkerad",
      "BUSY": "Upptagen",
      "DND": "Stör ej",
      "UNAVAILABLE": "Otillgänglig",
      "REJECTED": "Samtal avvisat",
      "CALL_FAILED": "Samtalet misslyckades"
    },
    "QUEUES": {
      "MORE": "Fler köer"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Ringer {number}… Du kan stänga den här fliken.",
    "NO_NUMBER": "Inget nummer angivet. Använd ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Ange telefonnummer...",
    "ACTIONS": {
      "DIAL": "Ring numret",
      "DIAL_FROM": "Välj numret du ringer från"
    },
    "DIAL_FROM": {
      "TITLE": "Ring från en inkorgs nummer"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonnummer krävs",
      "INVALID_FORMAT": "Ogiltigt format för telefonnummer"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Ljudinställningar och testning",
    "SELECT_DEVICE": "Välj enhet...",
    "SYSTEM_DEFAULT": "Systemstandard",
    "SAVED": "Sparad",
    "DISCONNECTED_SUFFIX": "ej ansluten",
    "DEVICE_DISCONNECTED": "Den valda enheten är inte ansluten. Samtal använder systemstandarden tills den är tillbaka.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Testa mikrofon",
      "STOP_TEST": "Stoppa test",
      "LEVEL": "Nivå:",
      "VERDICT": {
        "LISTENING": "Säg något i mikrofonen…",
        "SILENT": "Du hörs inte. Kontrollera att mikrofonen är på och att rätt mikrofon är vald.",
        "LOW": "Du hörs bara svagt. Välj en annan mikrofon eller justera ingångsvolymen i systeminställningarna.",
        "GOOD": "Bra ljud — du hörs tydligt."
      }
    },
    "SPEAKER": {
      "TITLE": "Högtalare",
      "TEST": "Testa högtalare",
      "TESTING": "Testar...",
      "VOLUME": "Volym:",
      "USING_DEFAULT": "Den valda utgången är inte tillgänglig — spelas upp via systemstandarden."
    },
    "DONE": "Klar",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Fel vid åtkomst till mikrofonen. Kontrollera behörigheterna.",
      "MICROPHONE_PERMISSION_DENIED": "Åtkomst till mikrofonen är blockerad. Tillåt den i webbläsarens webbplatsinställningar för att kunna använda telefonen.",
      "MICROPHONE_SILENT": "Din mikrofon fångar inget ljud. Kontrollera dina ljudinställningar.",
      "EXTENSION_REQUIRED": "Telefontillägget hittades inte. Installera eller aktivera det för att kunna använda mikrofonen.",
      "SPEAKER_TEST": "Fel vid test av högtalarutgången."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Upptagen"
  },
  "QUEUE_STATUS": {
    "READY": "Redo",
    "NOT_READY": "Tar inte emot samtal",
    "WRAP_UP": "Efterarbete",
    "BREAK": "Rast",
    "LUNCH": "Lunch",
    "AWAY": "Frånvarande",
    "DO_NOT_DISTURB": "Stör ej",
    "BUSINESS_TRIP": "Tjänsteresa",
    "OTHER_CALL": "Annat samtal",
    "QUEUE_CALL": "Kösamtal",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Ingen telefon",
    "PARTIALLY_READY": "Delvis redo",
    "MIXED": "Blandad",
    "CHAT_ONLINE": "Online (chatt)",
    "CHAT_BUSY": "Upptagen (chatt)",
    "CHAT_OFFLINE": "Offline (chatt)"
  }
}
